import Vue from 'vue';
import app from "./main";

export default new Vue({

    methods: {
        /**
         * Requiere que el usuario ingrese a su cuenta preexistente
         * @param callback
         */
        requireLogin(callback){
            this.$router.push('login');
            //this.$emit('requireLogin', callback);
        },
        /**
         * Requiere que el usuario ingrese a su cuenta preexistente o se registre y la confirme,
         * no existe requireRegister, ya que en ningun caso es obligatorio usar una cuenta nueva si ya tenes una
         * @param callback
         */
        requireAuthentication(callback){
            this.$router.push('login');
            //this.$emit('requireAuthentication', callback);
        },
        /**
         * Requiere que el usuario verifique su email
         * @param callback
         */
        requireEmailVerification(callback){
            //this.$emit('requireEmailVerification', callback);
        },
        /**
         * Requiere que el usuario ingrese a su cuenta o se registre, la confirme y compre una membresia
         * @param arg
         * @param
         */
        requireSubscription(arg){
            this.$emit('requireSubscription', arg || {});
        },

        /**
         * Avisarle al usuario que su cuenta fue baneada
         */
        userBanned(){
            this.$emit('userBanned');
        },

        changeLanguage(language) {
            document.querySelector('html').setAttribute('lang', language.code);
            app.$i18n.locale = language.code;
            Vue.http.headers.common['Accept-Language'] = language.code;

            if (this.$auth.check()) {
                let writeBaseUrl = process.env.VUE_APP_ROOT_API_WRITE.replace(/\/+$/, "");
                this.$http.post(`${writeBaseUrl}/user_last_lang`, {code: language.code});
            }

            try {
                localStorage.setItem('language.selected', language.code);
            } catch (e) {
            }

            this.$emit('languageChanged', language);

            this.$cms.forceLanguageUpdate();
        },
    },
});